import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import PageWrapper from 'components/PageWrapper';
import useQueryParams from 'hooks/useQueryParams';
import {
  getStripeSetupIntent,
  updateStripeCustomer,
} from 'services/account.service';
import toast from 'utils/toast';
import { useSelector } from 'react-redux';

const StripeSetupRedirect = ({ history }) => {
  const queryParams = useQueryParams();
  const account = useSelector((s) => s.settings.account);

  useEffect(() => {
    if (queryParams.setup_intent) {
      getStripeSetupIntent({ id: queryParams.setup_intent })
        .then((data) => {
          const intent = data[0];
          if (intent) {
            if (intent.status === 'succeeded') {
              return changeDefaultSource(intent.payment_method);
            }
          }
        })
        .catch((e) => {
          toast.error(e.message);
        })
        .finally(() => {
          history.replace(queryParams.return_url || '/settings/payment');
        });
    } else {
      history.replace('/settings/payment');
    }
  }, []);

  const changeDefaultSource = (sourceId) => {
    return updateStripeCustomer(account.stripe_id, {
      invoice_settings: {
        default_payment_method: sourceId,
      },
    }).then(() => {
      toast.success('Payment method successfully saved.');
    });
  };

  return (
    <PageWrapper loading title="Setting up payment method">
      <Box>Setting up payment method...</Box>
    </PageWrapper>
  );
};

export default StripeSetupRedirect;
